import { authAPI } from '../services/api';

let configCache = null;

export const getSocialConfig = async () => {
  if (configCache) return configCache;
  try {
    const res = await authAPI.getSocialConfig();
    configCache = res.data?.data || { google: {}, facebook: {} };
  } catch {
    configCache = { google: {}, facebook: {} };
  }
  return configCache;
};

const loadScript = (src) => new Promise((resolve, reject) => {
  const id = 'social-auth-' + src;
  if (document.getElementById(id)) return resolve();
  const s = document.createElement('script');
  s.id = id;
  s.src = src;
  s.onload = () => resolve();
  s.onerror = () => reject(new Error('Failed to load ' + src));
  document.head.appendChild(s);
});

export const loginWithGoogle = (clientId, { redirect, partnerType } = {}) => {
  const nonce = Math.random().toString(36).slice(2) + Date.now().toString(36);
  sessionStorage.setItem('google_nonce', nonce);
  if (partnerType) sessionStorage.setItem('google_partner_type', partnerType);
  else sessionStorage.removeItem('google_partner_type');
  sessionStorage.setItem('google_redirect', redirect || window.location.pathname + window.location.search);
  const params = new URLSearchParams({
    client_id: clientId,
    redirect_uri: window.location.origin + '/',
    response_type: 'id_token',
    scope: 'openid email profile',
    nonce,
    prompt: 'select_account'
  });
  window.location.href = 'https://accounts.google.com/o/oauth2/v2/auth?' + params.toString();
};

export const loginWithFacebook = (appId) => new Promise((resolve) => {
  if (!window.FB) window.fbAsyncInit = () => {};
  loadScript('https://connect.facebook.net/en_US/sdk.js')
    .then(() => new Promise((r) => {
      const check = setInterval(() => {
        if (window.FB) { clearInterval(check); r(); }
      }, 100);
      setTimeout(() => { clearInterval(check); r(); }, 8000);
    }))
    .then(() => new Promise((r) => {
      window.FB.init({ appId, version: 'v19.0', cookie: false, xfbml: false });
      window.FB.login((resp) => {
        if (resp?.authResponse?.accessToken) r(resp.authResponse.accessToken);
        else r(null);
      }, { scope: 'email,public_profile' });
    }))
    .then((token) => resolve(token))
    .catch(() => resolve(null));
});
